import React from 'react';
import { Button, Input, Select, message, Modal, Icon } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import UploadFile from '../../common/UploadFile';
import ExportUtil from '../../../common/ExportUtil';

const Option = Select.Option;

class Filter extends React.Component {
    state = {
        searchParams:{},
        businessList:[],
        visibleUpload:false,
        uploadMes:{}
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            searchParams: nextProps.searchParams 
        })
    }
    componentDidMount(){
        this.queryWithLevelByParams()
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'lineOfBusinessId') {
            searchParams.secondLineId = undefined;
        }
        this.setState({ searchParams });
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({ ...searchParams });
    }

    export = () => {
        this.props.export();
    }

    downTemplate = (params) => {
        ExportUtil.export(params, null, API_URL.execute.getStaffHandoverImportTemplate);
        message.success('正在下载中!')
    }

    downErrorReport = (params)=>{
        ExportUtil.export(params, null, API_URL.execute.getStaffHandoverImportFailList);
        message.success('正在下载中!')
    }

    onUplodChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else {
                const {uploadMes} = this.state;
                uploadMes.errorNum=file.response.errorNum;
                uploadMes.successNum=file.response.successNum;
                uploadMes.failNum=file.response.failNum;
                this.setState({uploadMes,visibleUpload:true})
            }
        }
    }

    render() {
        const { 
            searchParams, 
            businessList, 
            visibleUpload, 
            uploadMes 
        } = this.state;
        const { src, isMainUser } = this.props;
        const { curRole } = sessionStorage;
        const {
            handoverNum,
            handoverUserName,
            receiveUserName,
            investigationCode,
            investigationName,
            lineOfBusinessId
        } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusinessId == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add({typeValue:j.typeValue,typeConfigureId:j.typeConfigureId}));
            }
        });
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        return (
            <div>
                <div className="filter-bar" style={{ width: '100%', marginBottom: 0, overflow: 'hidden', maxHeight: 'unset', transition: 'all .1s linear 0s' }}>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">交接编号</label>
                        <Input
                            value={handoverNum}
                            placeholder="请输入"
                            style={{ width: 100 }}
                            onChange={e => this.handleChange(e.target.value, 'handoverNum')}
                        />
                    </div>
                    {
                        (src == 'User' || src == 'pmTransfer') &&
                            <div className="form-item">
                                <label htmlFor="" className="ui-label">项目编号</label>
                                <Input
                                    value={investigationCode}
                                    placeholder="请输入"
                                    onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                                />
                            </div>
                    }
                    {
                        (src == 'User' || src == 'pmTransfer') &&
                            <div className="form-item">
                                <label htmlFor="" className="ui-label">项目简称</label>
                                <Input
                                    value={investigationName}
                                    placeholder="请输入"
                                    onChange={e => this.handleChange(e.target.value, 'investigationName')}
                                />
                            </div>
                    }
                    {
                        (src == 'User' || src == 'pmTransfer') &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">业务线</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 120}}
                                value={lineOfBusinessId}
                                onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                            >
                                {businessOption}
                            </Select>
                        </div>
                        
                    }
                    {
                        (src == 'User' || src == 'pmTransfer') &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 120}}
                                disabled={!lineOfBusinessId}
                                value={searchParams.secondLineId}
                                onChange={value => this.handleChange(value, 'secondLineId')}
                            >
                                {secondLineOption}
                            </Select>
                        </div>
                    }
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">交接PM</label>
                        <Input
                            value={handoverUserName}
                            placeholder="请输入"
                            onChange={e => this.handleChange(e.target.value, 'handoverUserName')}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">接收PM</label>
                        <Input
                            value={receiveUserName}
                            placeholder="请输入"
                            onChange={e => this.handleChange(e.target.value, 'receiveUserName')}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">交接状态</label>
                        <Select
                            onChange={value => this.handleChange(value, 'status')}
                            style={{ width: 150 }}
                            placeholder="请选择"
                            allowClear={true}
                        >
                            <Option value="NEW">新建</Option>
                            <Option value="REJECT">被打回</Option>
                            <Option value="WAIT_INV_AREA_LEADER_CONFIRM">待领域leader审批</Option>
                            <Option value="WAIT_HANDOVER_LEADER_CONFIRM">待交接PM上级确认</Option>
                            <Option value="WAIT_RECEIVE_LEADER_CONFIRM">待接收PM上级确认</Option>
                            <Option value="ACTIVE">已完成</Option>
                        </Select>
                    </div>
                </div>
                <div className="filter-bar" style={{display: 'block'}}>
                    <div className="filter-bar-investigation" >
                        {
                            // src !== 'User' && isMainUser &&
                            <Button type="primary" onClick={()=>{this.props.update({},'add')}}>新建</Button>
                        }
                        <Button type="primary" onClick={this.export}>导出</Button>
                        {
                            (src == 'User' || src == 'pmTransfer') && (curRole == 'BO' || curRole == 'CSAL' || curRole == 'PML' ) &&
                            <span style={{float: 'right'}}>
                                <UploadFile
                                uploadUrl={API_URL.execute.importStaffHandover}
                                showUploadList={false}
                                onChange={this.onUplodChange}
                            >
                                <Button style={{color: '#fff', backgroundColor:'#ffcc33', border:'0'}} type="primary" >导入历史交接</Button>
                            </UploadFile>
                            </span>
                        }
                        {
                            (src == 'User' || src == 'pmTransfer') && (curRole == 'BO' || curRole == 'CSAL' || curRole == 'PML' ) &&
                            <Button type="primary" onClick={this.downTemplate}>下载模板</Button>
                        }
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        
                    </div>
                </div>
                <Modal 
                    visible={visibleUpload}
                    width={300}
                    footer={null}
                    closable={false}
                    >
                    <div style={{padding:'0 10px'}}>
                        <div style={{fontSize:'14px',fontWeight:'700',padding:'10px 0'}}><Icon type="exclamation-circle" style={{color:'#faad14',marginRight:'10px',fontSize:'20px'}}/>本次导入的PM交接数据:</div>
                        <p style={{marginLeft:'30px'}}>导入成功{uploadMes.successNum}条</p>
                        <p style={{marginLeft:'30px'}}>导入失败{uploadMes.failNum}条</p>
                        <div style={{textAlign:'right',marginTop:'20px'}}>
                            <Button size='large' style={{margin:'0 5px',fontSize:'12px'}} 
                            onClick={()=>{this.setState({visibleUpload:false})}}>关闭</Button>
                            <Button type="primary" size='large' style={{margin:'0 5px',backgroundColor:'#169bd5',fontSize:'12px',borderColor:'#169bd5'}} onClick={this.downErrorReport}>下载错误报告</Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/user/transfer/PMFilter.js